import { configureStore } from '@reduxjs/toolkit';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import founderReducer from '../features/founders/founderSlice';
import angelReducer from '../features/angels/angelSlice';
import vcReducer from '../features/vcs/vcSlice';
import acceleratorReducer from '../features/accelerators/acceleratorSlice';
import reportReducer from '../features/reports/reportSlice';
import transactionReducer from '../features/transactions/transactionSlice';
import settingReducer from '../features/setting/settingSlice';

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    founders: founderReducer,
    angels: angelReducer,
    vcs: vcReducer,
    accelerators : acceleratorReducer,
    reports : reportReducer,
    transactions: transactionReducer,
    setting: settingReducer
  },
});